// SINGLE SOURCE OF TRUTH for all pricing displays. Update here, not in components.
// Single intro-rate model: everyone gets the intro price for their first
// billing cycle (12 months on monthly, 1 year on annual), then renews at the
// base price automatically. No tiers, no slots, no lock period. The step-up
// is enforced by Stripe coupons on the backend — the frontend only displays
// these numbers.
export const PRICING = {
  monthly: {
    intro: 19,
    base: 29,
    introMonths: 12,
  },
  annual: {
    intro: 190,
    base: 290,
    introYears: 1,
  },
};
